module.exports = __webpack_public_path__ + "static/media/leukocytes-bottom.1983b4c3.png";